/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Legaroo_AriaInputs */

const en_service_legaroo_aria = /** @type {(inputs: Service_Legaroo_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link to Legaroo legal service`)
};

const fr_service_legaroo_aria = /** @type {(inputs: Service_Legaroo_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lien vers le service juridique Legaroo`)
};

/**
* | output |
* | --- |
* | "Link to Legaroo legal service" |
*
* @param {Service_Legaroo_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_legaroo_aria = /** @type {((inputs?: Service_Legaroo_AriaInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Legaroo_AriaInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_legaroo_aria(inputs)
	return fr_service_legaroo_aria(inputs)
});